import React from 'react';
import TemplatePinCard, { TemplatePinCardPlaceholder } from './TemplatePinCard';

function TemplatePinListItem(props) {
  return <TemplatePinCard {...props} layout="list" />;
}

export function TemplatePinListItemPlaceholder() {
  return <TemplatePinCardPlaceholder layout="list" />;
}

export default React.memo(TemplatePinListItem);
